<div class="d-flex justify-content-between flex-wrap footer align-items-center" id="footer">
	<div class="left">
		<div class="image-cont" >
			<img src="../../../assets/images/Toyota_logo.png" alt="logo" /> 
		</div>
		<span>Copyrighted © 2023</span>
	</div>
</div>